import { inputResult } from "../Submit/SaveAnswer";


export function transformMcToResult(input:JQuery, results:inputResult, points:number, possible:number){
    
    const options = input.find(".form-check");

    results.answer = (results.answer !== '') ? results.answer : [];

    options.each((ind, obj) => {
        $(obj).find("input").prop('disabled', true);
        ind = ind.toString();
        let [add, title] = '';
        if (results.answer.includes(ind)){
            $(obj).find("input[value=" + ind + "]").attr("checked", "checked"); // select
            // selected
            if (results.correct.includes(ind)){
                // and was the richt choice
                add = 'radio_klausur_correct'
            } else {
                // should not have been selected
                add = 'radio_klausur_false';
                title = 'Diese Antwort war falsch'
            }
        } else {
            // not selected
            if (results.correct.includes(ind)){
                // not selected but was true
                add = 'radio_klausur_missed';
                title = 'Diese Antwort wäre richtig gewesen';
            } else {
                // not selected but was false to select either way -> so no problem 
                add = 'radio_klausur';
            }
        }        

        $(obj).addClass(add);
        $(obj).attr("title", title);
    })
    addPointMessage(input, results)
}

export function addPointMessage($input:JQuery, results:inputResult){
    
    const pointsText = (Number(results.possible) == 1) ? "Punkte" : "Punkten"

    const rate = Number(results.points) / Number(results.possible)

    let c;
    if (rate < 0.2){
        c = "danger"
    } else if (rate < 0.5){
        c = "warning"
    } else {
        c = "success"
    }
    
    $input.append(
        '<div class="text-' + c + ' mt-1">Für diese Antwort gab es ' + roundToTwo(Number(results.points)) + ' von ' + roundToTwo(Number(results.possible)) + ' ' + pointsText + '</div>'
    )
}

export function roundToTwo(num) {
    if (num > 0){
        return +(Math.round(num + "e+2")  + "e-2");
    } else {
        return num;
    }
}